import crudHandlers from './_crud'

const initialState = {
    entities: {},
    unitsWialonInfo: [],
    lastFetchedUnitsWialonInfo: null,
}

export default (state=initialState, action) => {
    const { type } = action
    switch (type) {
        case 'UNITSWIALONINFO': {
            return {
                ...state,
                unitsWialonInfo: action.payload,
                lastFetchedUnitsWialonInfo: Date.now(),
            }
        }
        default: {
            state = crudHandlers(state, action, 'programing_service')
            return state
        }
    }
}
